export const useSubdomain = () => {
  let subdomain: string | null = null
  if (import.meta.server) {
    const { ssrContext } = useNuxtApp()
    subdomain = ssrContext?.event.node.req.headers.host?.split('.')[0]!
  } else {
    subdomain = window.location.hostname.split('.')[0]!
  }
  return subdomain
}